import { render, staticRenderFns } from "./BulletedList.vue?vue&type=template&id=922153fa&"
import script from "./BulletedList.vue?vue&type=script&setup=true&lang=js&"
export * from "./BulletedList.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports